import { Link } from 'react-router-dom';
import TaishunGlobalLogo from '../../assets/images/TaishunGlobalLogo.jpeg';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src={TaishunGlobalLogo} 
                alt="Taishun Global Logo" 
                className="w-24 h-20 object-contain"
              />
              <span className="text-xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                Taishun Global
              </span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              <strong>Leading manufacturer of premium non-woven materials</strong> with 20 years of expertise. 
              We deliver sustainable, high-performance solutions to industries worldwide.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/applications" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Applications
                </Link>
              </li>
              <li>
                <Link to="/product-characteristics" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Product
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-2 text-gray-300">
              <p className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                info@taishunglobal.com
              </p>
              <p className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                +86 13862299662
              </p>
              <p className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                Yinbei County, Shaxi Town, Taicang, Jiangsu, CN
              </p>
            </div>
          </div>
        </div>
        
        {/* <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Taishun Global. All rights reserved. | 🌐 Worldwide Shipping | 20 Years of Non-Woven Expertise
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-teal-400 text-sm mt-2 md:mt-0 cursor-pointer"
          >
            Website Builder
          </a>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
